import { useRouteLoaderData } from 'react-router';

import { useCurrentLocale } from 'contexts/CurrentLocaleContext';

export function useSearchJobsRouteLoaderData() {
  const { currentLocale } = useCurrentLocale();
  const loaderData = useRouteLoaderData(`search-jobs-${currentLocale}`)!;

  const { synonym, facetCounts } = loaderData ?? {};

  const {
    familyId,
    jobSynonym: { name },
  } = synonym ?? {
    familyId: null,
    jobSynonym: { name: null },
  };

  return { jobSynonymName: name, jobFamilyId: familyId, facetCounts };
}
